import { render, staticRenderFns } from "./VHeader.vue?vue&type=template&id=0c6514bb&scoped=true"
import script from "./VHeader.vue?vue&type=script&lang=ts"
export * from "./VHeader.vue?vue&type=script&lang=ts"
import style0 from "./VHeader.vue?vue&type=style&index=0&id=0c6514bb&prod&lang=scss&scoped=true"
import style1 from "./VHeader.vue?vue&type=style&index=1&id=0c6514bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6514bb",
  null
  
)

export default component.exports